import { gql } from '@web/federation/gql'

export const RecentOrderBookingSectionQuery = gql(`
  query RecentOrderBookingSection {
    me {
      ...on MeSucceed {
        prevBookings(months: 3, size: 15){
          ...RecentOrderBookingSection_PrevBooking
        } 
        prevOrders(months: 3, size: 15) {
          ...RecentOrderBookingSection_PrevBooking
        }
        crmStamp {
          totalCount
          stampPageUrl {
            webUrl
          }
        }
      }
    }
  }

  fragment RecentOrderBookingSection_User on User {
    id
  }

  fragment RecentOrderBookingSection_PrevBooking on PrevBooking {
    id
    isBizItemOpen
    landingUrl
    bookingCount
    businessImageUrl
    businessName
    businessId
    bizItemId
    placeSummary {
      id
      ...RecentOrderBookingSection_PlaceSummary
    }
  }

  fragment RecentOrderBookingSection_PlaceSummary on PlaceSummary {
    id
    name
    address(format: DO_SI_DONG) {
      formattedAddress
    }
    notExist
    coordinate {
      longitude
      latitude
    }
  }
`)
